// src/app/NewLeadsBadge.tsx
import { useQuery } from "@tanstack/react-query";

import { listQuery } from "@/features/platform/api";

/**
 * عدد الليدز بحالة "جديد" فقط (لم يتم التعامل معها اطلاقاً) — عدد حقيقي من قاعدة البيانات
 * (status=NEW)، لا تخمين محلي كما في شارة "تنبيهات" بالهيدر. يتحدَّث تلقائياً كل دقيقة،
 * وينزل فوراً بمجرد ما الأدمن يأخذ أي إجراء على الليد (تم التواصل/تحويل/رفض).
 */
export function NewLeadsBadge() {
  const { data } = useQuery({ ...listQuery("leads", { status: "NEW", page_size: 1 }), refetchInterval: 60_000 });
  const count = data?.total ?? 0;
  if (count === 0) return null;
  return (
    <span className="mono inline-flex h-[19px] min-w-[19px] items-center justify-center rounded-full px-1 text-[10px] text-white"
      style={{ background: "linear-gradient(145deg,#F0736A,#B3352C)", boxShadow: "0 0 14px rgba(240,115,106,.7)" }}
      aria-label={`${count} عميل محتمل جديد لم يتم التعامل معه`}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
